// extracted by mini-css-extract-plugin
export default {"login-container":"Login_login-container__G5s4s","login-img":"Login_login-img__qibGb"};